import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=a00cbe3e&scoped=true"
import script from "./TheSidebar.vue?vue&type=script&lang=js"
export * from "./TheSidebar.vue?vue&type=script&lang=js"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&id=a00cbe3e&prod&scoped=true&lang=css"
import style1 from "./TheSidebar.vue?vue&type=style&index=1&id=a00cbe3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00cbe3e",
  null
  
)

export default component.exports